import DateFnsUtils from '@date-io/date-fns';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog/Dialog';
import DialogContent from '@material-ui/core/DialogContent/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle/DialogTitle';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormLabel from '@material-ui/core/FormLabel';
import Grid from '@material-ui/core/Grid';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider
} from '@material-ui/pickers';
import { makeStyles } from '@material-ui/styles';
import React, { useState } from 'react';
import { getRelatorioListagemVisitasGeral } from '../../../services/RelatorioService';
import { MessageValues } from '../../../values/MessageValues';
import ProgressFullScreen from '../../../components/Compartilhados/ProgressFullScreen';
import SnackbarCustom from '../../../components/Compartilhados/Snackbar';

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    marginRight: 10,
    marginLeft: 10,
    backgroundColor: theme.palette.background.paper,
    borderBottomLeftRadius: 20,
    borderBottomRightRadius: 20,
    borderTopRightRadius: 35,
    borderTopLeftRadius: 35
  },
  toolbar: {
    marginRight: 10,
    marginLeft: 10
  },
  divFab: {
    zIndex: 2
  },
  fab: {
    position: 'fixed',
    bottom: theme.spacing(2),
    right: theme.spacing(2)
  }
}));

function DialogImpressaoVisitasGeral(props) {
  const FILTRO_SEM_PERIODO = 0;
  const FILTRO_POR_PERIODO = 1;
  const { open, setOpen } = props;
  const [tipoFiltroPeriodo, setTipoFiltroPeriodo] = useState(
    FILTRO_SEM_PERIODO
  );
  const [dataInicial, setDataInicial] = useState(null);
  const [dataFinal, setDataFinal] = useState(null);
  const [loading, setLoading] = React.useState(false);
  const [showMessageSnack, setShowMessageSnack] = useState(false);
  const [messageSnack, setMessageSnack] = useState('');
  const [typeSnack, setTypeSnack] = useState('success');

  async function chamarServiceRelatorioListagemVisitas() {
    try {
      setLoading(true);
      setOpen(false);
      let relatorio = await getRelatorioListagemVisitasGeral(
        dataInicial,
        dataFinal
      );
      if (relatorio.isSuccess) {
        setDataFinal(null);
        setDataInicial(null);
        setTipoFiltroPeriodo(FILTRO_SEM_PERIODO);
        const fileURL = window.URL.createObjectURL(relatorio.result);
        const link = document.createElement('a');
        link.href = fileURL;
        link.setAttribute('download', `Listagem Visitas Geral.pdf`);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        setLoading(false);
        setTypeSnack('success');
        setMessageSnack('Relatório gerado com sucesso.');
        setShowMessageSnack(true);
      } else {
        setOpen(true);
        setLoading(false);
        setTypeSnack('error');
        setMessageSnack(relatorio.message);
        setShowMessageSnack(true);
      }
    } catch (e) {
      setOpen(true);
      setLoading(false);
      setTypeSnack('error');
      setMessageSnack(MessageValues.erro_catch);
      setShowMessageSnack(true);
    }
  }

  const aoModificarDataInicialPersonalizada = async date => {
    setDataInicial(date);
  };

  const aoModificarDataFinalPersonalizada = async date => {
    setDataFinal(date);
  };

  function aoModificarTipoFiltroPeriodo(filtro) {
    if (filtro === FILTRO_SEM_PERIODO) {
      setDataInicial(null);
      setDataFinal(null);
    }
    setTipoFiltroPeriodo(filtro);
  }

  return (
    <Grid container spacing={2}>
      <Grid item md={12} xs={12}>
        <SnackbarCustom
          verticalOrientation="bottom"
          horizontalOrientation="center"
          open={showMessageSnack}
          setOpen={setShowMessageSnack}
          message={messageSnack}
          duration={2000}
          type={typeSnack}
        />
      </Grid>
      <Grid item md={12} xs={12}>
        <ProgressFullScreen open={loading} setOpen={setLoading} />
      </Grid>
      <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth={'xs'}
        fullWidth
        onClose={e => setOpen(false)}>
        <DialogTitle id="alert-dialog-title">
          {'Escolha os filtros para impressão'}
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item md={12} xs={12}>
              <FormControl
                component="fieldset"
                variant={'outlined'}
                size={'medium'}
                margin={'dense'}
                color={'primary'}>
                <FormLabel component="legend">
                  Escolha o tipo de filtro por período
                </FormLabel>
                <RadioGroup
                  aria-label="quiz"
                  name="quiz"
                  value={tipoFiltroPeriodo}>
                  <Grid container spacing={2}>
                    <Grid item md={6} xs={6}>
                      <FormControlLabel
                        onClick={e => setTipoFiltroPeriodo(FILTRO_SEM_PERIODO)}
                        value={FILTRO_SEM_PERIODO}
                        control={<Radio color="primary" />}
                        label="Todos"
                      />
                    </Grid>
                    <Grid item md={6} xs={6}>
                      <FormControlLabel
                        onClick={e => setTipoFiltroPeriodo(FILTRO_POR_PERIODO)}
                        value={FILTRO_POR_PERIODO}
                        control={<Radio color="primary" />}
                        label="Período"
                      />
                    </Grid>
                  </Grid>
                </RadioGroup>
              </FormControl>
            </Grid>
            {tipoFiltroPeriodo === FILTRO_POR_PERIODO && (
              <Grid item md={12} xs={12}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <Grid container justify="space-around">
                    <KeyboardDatePicker
                      fullWidth
                      margin="dense"
                      inputVariant="outlined"
                      orientation="landscape"
                      id="dataInicialPersonalizada"
                      label="Data inicial"
                      format="dd/MM/yyyy"
                      size="small"
                      value={dataInicial}
                      onChange={aoModificarDataInicialPersonalizada}
                      KeyboardButtonProps={{
                        'aria-label': 'change date'
                      }}
                      InputAdornmentProps={{ position: 'end' }}
                    />
                  </Grid>
                </MuiPickersUtilsProvider>
              </Grid>
            )}
            {tipoFiltroPeriodo === FILTRO_POR_PERIODO && (
              <Grid item md={12} xs={12}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <Grid container justify="space-around">
                    <KeyboardDatePicker
                      fullWidth
                      margin="dense"
                      inputVariant="outlined"
                      orientation="landscape"
                      id="dataFinalPersonalizada"
                      label="Data final"
                      format="dd/MM/yyyy"
                      size="small"
                      value={dataFinal}
                      onChange={aoModificarDataFinalPersonalizada}
                      KeyboardButtonProps={{
                        'aria-label': 'change date'
                      }}
                      InputAdornmentProps={{ position: 'end' }}
                    />
                  </Grid>
                </MuiPickersUtilsProvider>
              </Grid>
            )}
            <Grid item md={12} xs={12}>
              <Button
                size={'small'}
                fullWidth
                variant={'outlined'}
                onClick={e => chamarServiceRelatorioListagemVisitas()}>
                IMPRIMIR
              </Button>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </Grid>
  );
}

export default DialogImpressaoVisitasGeral;
